
import { Drawer } from "element-ui"
// import drawerHeader from "./drawer-header.vue"
import countControl from "./count-control.vue"
import { COLLECT_INIT_WIDTH, GTM_FREEBLE } from "./const.js"
import slotWidget from "./slot-widget"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import { handleAddToCartV2, handleModifyCartV2 } from "@/utils/cartResponse"
import { trackViewItemList, trackSelectItem } from "@/utils/track"
export default {
  API: ["open"],
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
    slotWidget,
    countControl
  },
  inject: {
    getProId: {
      default: null
    },
    getStoreId: {
      default: null
    },
    source: {
      default: null
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    canSelect: {
      type: Boolean,
      default: true
    },
    proId: {
      type: [String, Number],
      default: ""
    },
    storeId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      drawerSize: COLLECT_INIT_WIDTH,
      prevInfo: null,
      expandedGroups: {}
    }
  },
  computed: {
    isMax() {
      return this.info.selectedCount === this.info.maxTradeQty || !this.info.maxTradeQty
    },
    // 展示的分组数据
    displayGroups() {
      return this.groupedOptItemList.map(group => {
        const isExpanded = !!this.expandedGroups[group.groupNo]
        const limit = 8
        return {
          ...group,
          displayItems: isExpanded ? group.optItemList : group.optItemList.slice(0, limit),
          hasMore: group.optItemList.length > limit,
          isExpanded,
          isMax: group.totalCount === group.maxRewardQty || !group.maxRewardQty
        }
      })
    },
    groupedOptItemList() {
      const groupedList = this.info.groupedOptItemList
      if (groupedList && groupedList.length) {
        groupedList.forEach(v => {
          v.totalCount = 0
          if (v.optItemList && v.optItemList.length) {
            v.optItemList.forEach(_v => (v.totalCount += _v.count || 0))
          }
        })
      }
      return groupedList
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal) {
          if (this.prevInfo && JSON.stringify(this.prevInfo) !== "{}") {
            if (newVal.maxTradeQty > 0 && this.prevInfo) {
              // 前一次的dialogInfo.proNum或者dialogInfo.maxTradeQty 与当前接口返回的不相同
              if (this.prevInfo.proNum != newVal.proNum || this.prevInfo.maxTradeQty != newVal.maxTradeQty) {
                this.open()
              }
            }
          } else {
            // 第一次进入
            if (newVal.maxTradeQty && newVal.maxTradeQty != newVal.selectedCount) {
              this.open()
            }
          }
          this.prevInfo = newVal
        }
      },
      immediate: true
    }
  },
  updated() {
    if (this.info?.optItemList?.length === 0) return
    trackViewItemList(this.info.optItemList, GTM_FREEBLE, GTM_FREEBLE)
  },
  methods: {
    handleSlotDelete({ skuId }) {
      this.$refs[`countControl_${skuId}`][0].reduce()
    },
    getSelectedContent(item) {
      if (item.totalCount === item.maxRewardQty) {
        return this.$t("collect.completed")
      } else {
        return this.$t("collect.selectNum", { num: item.maxRewardQty })
      }
    },
    toggleExpand(groupKey) {
      this.$set(this.expandedGroups, groupKey, !this.expandedGroups[groupKey])
    },
    getAbnormalStateText(item) {
      const state = item?.merchantId
      switch (state) {
        case 0:
          // 仅香港
          return this.$t("cart.salesAreaOnlyHKPickUp")
        case 1:
          // 仅澳门
          return this.$t("cart.salesAreaOnlyMacaoPickUp")
        default:
          return ""
      }
    },
    _fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return "$" + (num / 100).toFixed(2)
    },
    open() {
      this.visible = true
      this.$bus.$emit("inner-drawer", true)
    },
    handleClose() {
      this.$bus.$emit("inner-drawer", false)
      this.visible = false
    },
    handleBtnClose() {
      if (!this.info?.selectedCount) return
      this.handleClose()
    },
    async handleSelect(item, canSelect) {
      if (!canSelect) return
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const wares = [{ sku: item.skuId, beforeCount: 0, count: 1, checked: 1 }]
      const [error, data] = await handleAddToCartV2({
        storeId: this.storeId || (this.getStoreId && this.getStoreId()),
        wares,
        sort: 1,
        otherParams: {
          giftProId: this.proId || (this.getProId && this.getProId())
        }
      })
      if (error) {
        // this.$message.error(error.result)
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
      }
      loading.close()
    },
    handleGoDetail(val) {
      val.parentId = GTM_FREEBLE
      val.layoutName = GTM_FREEBLE
      trackSelectItem(val, () => {
        this.$navigation.push(
          `${this.MAIN_ORIGIN}${this.MAIN_PATH}/p/${encodeURIComponent(val.wareName)}/i/${val.skuId}.html`
        )
      })
    }
  }
}
